import { Box, Stack, Typography } from "@mui/material";

import openaiLogo from "../../../../../assets/openai-logo.svg";
import openaiLogoWhite from "../../../../../assets/openai-logo-white.svg";
import { useDarkThemeCheck } from "../../../../../Components/hooks/useDarkThemeCheck";

export const cyIds = {
  header: "openai-header",
  logo: "openai-logo",
};

const OpenAIAssetsTabHeader = ({ connectButton }: { connectButton: React.JSX.Element }) => {
  const isDarkMode = useDarkThemeCheck();

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ pt: 2, pb: 2.5 }}>
      <Typography variant="h1" data-cy="openai-header">
        <Box
          component="img"
          src={isDarkMode ? openaiLogoWhite : openaiLogo}
          sx={{ height: "0.8em", width: "auto", mr: 1 }}
          data-cy="openai-logo"
          aria-hidden
          alt-text="OpenAI logo"
        />
        OpenAI
      </Typography>
      {connectButton}
    </Stack>
  );
};

export default OpenAIAssetsTabHeader;
